import {
  Table,
  TableRow,
  TableCell,
  Paragraph,
  TextRun,
  WidthType,
  AlignmentType,
  BorderStyle,
} from "docx";

export function ModelWorldVleresimGjinor1(tableContent) {
  const docSections = [];

  // Funksion ndihmës për qeliza
  const createCell = (text, options = {}) =>
    new TableCell({
      children: [
        new Paragraph({
          children: [
            new TextRun({ text: String(text), size: 20, ...options.textRun }),
          ],
          alignment: options.alignment ?? AlignmentType.CENTER,
        }),
      ],
      shading: options.shading,
      verticalAlign: "center",
      margins: { top: 100, bottom: 100, left: 100, right: 100 },
      columnSpan: options.columnSpan,
    });

  const headerRed = { fill: "ED1D25" };
  const blue = { fill: "bbdefb" };
  const pink = { fill: "f8bbd0" };

  const boldWhite = { bold: true, color: "FFFFFF" };
  const bold = { bold: true };

  const tableRows = [];

  // Rreshti i parë i header-it
  tableRows.push(
    new TableRow({
      children: [
        createCell("Nr. Subjekti", { shading: headerRed, textRun: boldWhite }),
        createCell("Nr. moderatorëve", {
          shading: headerRed,
          textRun: boldWhite,
          columnSpan: 3,
        }),
        createCell("Nr. të ftuarve", {
          shading: headerRed,
          textRun: boldWhite,
          columnSpan: 3,
        }),
      ],
    })
  );

  // Rreshti i dytë i header-it
  tableRows.push(
    new TableRow({
      children: [
        createCell("", { textRun: bold }),
        createCell("Gjithsej", { textRun: bold }),
        createCell("Meshkuj", { shading: blue, textRun: bold }),
        createCell("Femra", { shading: pink, textRun: bold }),
        createCell("Gjithsej", { textRun: bold }),
        createCell("Meshkuj", { shading: blue, textRun: bold }),
        createCell("Femra", { shading: pink, textRun: bold }),
      ],
    })
  );

  // Rreshtat e të dhënave
  for (const row of tableContent) {
    const modM = parseInt(row["Nr. moderatorëve meshkuj"] || 0);
    const modF = parseInt(row["Nr. moderatorëve Femra"] || 0);
    const ftM = parseInt(row["Nr. të ftuarve Meshkuj"] || 0);
    const ftF = parseInt(row["Nr. të ftuarve Femra"] || 0);

    tableRows.push(
      new TableRow({
        children: [
          createCell(row["Nr. Subjekti"], {
            alignment: "left",
            textRun: { bold: true },
          }),
          createCell(modM + modF),
          createCell(modM, { shading: blue }),
          createCell(modF, { shading: pink }),
          createCell(ftM + ftF),
          createCell(ftM, { shading: blue }),
          createCell(ftF, { shading: pink }),
        ],
      })
    );
  }

  const table = new Table({
    rows: tableRows,
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: {
      top: { style: BorderStyle.SINGLE, size: 1, color: "999999" },
      bottom: { style: BorderStyle.SINGLE, size: 1, color: "999999" },
      left: { style: BorderStyle.SINGLE, size: 1, color: "999999" },
      right: { style: BorderStyle.SINGLE, size: 1, color: "999999" },
      insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: "999999" },
      insideVertical: { style: BorderStyle.SINGLE, size: 1, color: "999999" },
    },
  });

  docSections.push(table);
  return docSections;
}
